import Loadable from 'react/components/loadable';

const EnableGeneralAccessDashboardV2Modal = Loadable({
  loader: () => import('../../pages/dashboard/components/enable_general_access_dashboard_v2_modal'),
  type: 'modal',
});

angular
  .module('gym')
  .value('EnableGeneralAccessDashboardV2Modal', EnableGeneralAccessDashboardV2Modal);
